import { connect } from 'react-redux';
import Main from './main';

import { setUseDesktopLayout } from '../reducers/app.reducers';
import { removeMessageByIndex } from '../reducers/message.reducers';

const mapStateToProps = state => ({
  inApp: state.app.inApp,
  messages: state.message.messages,
});

const mapDispatchToProps = dispatch => ({
  removeMessageByIndex: messageIndex => dispatch(removeMessageByIndex(messageIndex)),
  setUseDesktopLayout: useDesktopLayout => dispatch(setUseDesktopLayout(useDesktopLayout)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
